/// <amd-module name="Traceability/Common/Linking" />
import { ITfsPageService } from "Tfs/Platform/Page";
import { ITraceabilityLinkingService } from "Traceability/Common/Contracts";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";

// Copied selectively from Tfs\Web\extensions\build\vss-build-web\common\client\Linking.ts

export namespace RouteParameters {
    export const BuildId = "buildId";
    export const Project = "project";
    export const DefinitionId = "definitionId";
    export const CurrentRunId = "currentRunId";
}

export class TraceabilityLinkingService extends VssService implements ITraceabilityLinkingService {
    public getRunUrl(pageContext: IVssPageContext, runId: number, project?: string): string {
        const routeValues: { [key: string]: string } = {};
        routeValues[RouteParameters.BuildId] = runId + "";
        routeValues[RouteParameters.Project] = this._getProject(pageContext, project);

        return routeUrl(pageContext, "ms.vss-build-web.ci-results-hub-route", routeValues);
    }

    public getPipelineDefinitionUrl(pageContext: IVssPageContext, definitionId: number, project?: string): string {
        const routeValues: { [key: string]: string } = {};
        routeValues[RouteParameters.DefinitionId] = definitionId + "";
        routeValues[RouteParameters.Project] = this._getProject(pageContext, project);

        return routeUrl(pageContext, "ms.vss-build-web.pipelines-hub-route", routeValues);
    }

    public getRunViewTraceabilityUrl(pageContext: IVssPageContext, routeId: string, runId: number, project?: string, params?: { [key: string]: string }): string {
        const routeValues: { [key: string]: string } = params || {};
        routeValues[RouteParameters.CurrentRunId] = runId + "";
        routeValues[RouteParameters.Project] = this._getProject(pageContext, project);

        return routeUrl(pageContext, routeId, routeValues);
    }

    private _getProject(pageContext: IVssPageContext, project?: string): string {
        const tfsPageService = pageContext.getService<ITfsPageService>("ITfsPageService");
        const tfsPageData = tfsPageService.getData();
        if (!project && tfsPageData && tfsPageData.project) {
            project = tfsPageData.project.name;
        }

        return project || "";
    }
}

Services.add("ITraceabilityLinkingService", { serviceFactory: TraceabilityLinkingService });
